import { getMessaging, isSupported } from 'firebase/messaging';
import { app } from './firebaseConfig';

export const getMessagingIfSupported = async () => {
  if (await isSupported()) {
    return getMessaging(app);
  }
  return null;
};
